import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class TranslateService {
  private http = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);

  private data: any;

  getData(path: string, language?: string) {
    return new Promise((resolve, reject) => {
      if (!language) {
        if (isPlatformBrowser(this.platformId)) {
          language = navigator.language.includes('es') ? 'es' : 'en';
        } else {
          language = 'en';
        }
      }

      this.http.get(`${path}${language}.json`).subscribe({
        next: (data) => {
          this.data = data;
          resolve(true);
        },
        error: (err) => {
          console.error(err);
          this.http.get(`${path}en.json`).subscribe({
            next: (data) => {
              this.data = data;
              resolve(true);
            },
            error: (err) => resolve(false),
          });
        },
      });
    });
  }

  getTranslate(key: string): string {
    return this.data[key] || key;
  }

  getCurrentLanguage() {
    const language = this.data['head.language'];
    return language === 'Spanish' ? 'en' : 'es';
  }
}
